/**
 * Collects manual Amplitude event attributes from button dataset.
 *
 * @param {HTMLElement} button Button element.
 * @return {Object} Event properties.
 */
const getAmplitudeProperties = ( button ) => {

	const properties = {
		'entry_url': window.location.href,
	};

	[ ...button.attributes ].forEach( ( attribute ) => {

		if ( ! attribute?.name?.startsWith( 'data-amplitude-' ) || attribute.name === 'data-amplitude-event-name' ) {

			return;

		}

		const key = attribute.name
			.replace( 'data-amplitude-', '' )
			.replace( /-/g, '_' )
			.trim();
		const value = `${ attribute.value || '' }`.trim();

		if ( ! key ) {

			return;

		}

		properties[ key ] = value || null;

	} );

	return properties;

};

/**
 * Sends manual Amplitude button event, if configured.
 *
 * @param {MouseEvent} event Click event.
 * @return {void}
 */
const handleAmplitudeButtonClick = ( event ) => {

	const target = event.target;
	if ( ! ( target instanceof Element ) ) {

		return;

	}

	const button = target.closest( '[data-amplitude-event-name]' );
	if ( ! ( button instanceof HTMLElement ) ) {

		return;

	}

	const eventName = button.getAttribute( 'data-amplitude-event-name' )?.trim();
	if ( ! eventName ) {

		return;

	}

	const track = window?.amplitude?.track;
	if ( typeof track !== 'function' ) {

		return;

	}

	track( eventName, getAmplitudeProperties( button ) );

};

/**
 * Initializes delegated click tracking for button-level Amplitude events.
 *
 * @return {void}
 */
export const amplitudeButtonEvents = () => {

	document.addEventListener( 'click', handleAmplitudeButtonClick );

};
